import ChemicalListView from "../views/ZenKit/ChemicalListView";
import ConsumablesListViews from "../views/ZenKit/ConsumablesListViews";
import ZenKitHome from "../views/ZenKit/ZenKitHome";

export default [
  {
    path: '/Zenkit',
    component: ZenKitHome,
    name: 'ZenkitHome',
    children: [
      {
        path: 'Chemicals',
        component: ChemicalListView,
        name: "ChemicalListView"
      },
      {
        path: 'Consumables',
        component: ConsumablesListViews,
        name: "ConsumablesListViews"
      }
    ]
  }
]